import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    // 过渡页
    {path: '/'},
    // 登录页面
    {path: '/login', name: 'login', component: () => import('../views/login')},
    // 404页面
    {path: '/error404', name: 'error404', component: () => import('../views/error404')},
    // 首页
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/index'),
        children: [

            // 回收-banner管理
            {path: 'banner', name: 'HS_BANNER', component: () => import('../views/recovery/banner/banner')},
            // 回收-类别管理
            {path: 'category', name: 'HS_LBGL', component: () => import('../views/recovery/category/category')},
            // 回收-订单管理
            {path: 'recovery-order', name: 'HS_DDGL', component: () => import('../views/recovery/order/order')},
            // 回收-数据统计
            {path: 'charts', name: 'HS_SJTJ', component: () => import('../views/recovery/charts/charts')},
            // 回收-车辆过磅
            {path: 'vehicle-weigh', name: 'HS_CLGB', component: () => import('../views/recovery/vehicle/vehicle')},
            // 回收-订单评价
            {path: 'evaluate', name: 'HS_DDPJ', component: () => import('../views/recovery/evaluate/evaluate')},
            // 商城-商品管理
            {path: 'mall-goods', name: 'SC_SPGL', component: () => import('../views/mall/goods/goods')},
            // 商城-订单管理
            {path: 'mall-order', name: 'SC_DDGL', component: () => import('../views/mall/order/order')},

            // 用户-用户管理
            {path: 'user', name: 'YH_YHGL', component: () => import('../views/user/user/user')},
            // 用户-回收员管理
            {path: 'recycler', name: 'YH_HSYGL', component: () => import('../views/user/recycler/recycler')},
            // 用户-投诉及意见反馈
            {path: 'feedback', name: 'YH_TSJY', component: () => import('../views/user/feedback/feedback')},
            // 用户-星标用户
            {path: 'star-user', name: 'YH_XBYH', component: () => import('../views/user/star/starUser')},
            // 用户-活动用户
            {path: 'activity-user', name: 'YH_HDYH', component: () => import('../views/user/user/activityUser')},
            // 系统-管理员管理
            {path: 'admin', name: 'XT_GLYGL', component: () => import('../views/system/admin/admin')},
            // 系统-角色管理
            {path: 'role', name: 'XT_JSGL', component: () => import('../views/system/role/role')},
            // 系统-配置管理
            {path: 'config', name: 'XT_PZGL', component: () => import('../views/system/config/config')},
            // 系统-开通地区
            {path: 'open', name: 'XT_KTDQ', component: () => import('../views/system/open/open')},
            {path: 'open-range-map', name: 'XT_YYFW_MAP', component: () => import('../views/system/open/rangeMap')},
            // 系统-租户运营范围
            {path: 'range', name: 'XT_YYFW', component: () => import('../views/system/range/range')},
            {path: 'range-map', name: 'XT_YYFW_MAP', component: () => import('../views/system/range/rangeMap')},
            {path: 'recycler-range', name: 'XT_HSY_MAP', component: () => import('../views/user/recycler/components/recycler-range')},
        ]
    }
];

const router = new VueRouter({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes
});

export default router
